

















import Vue from "vue";

export default Vue.extend({
  name: "MainVideoSection",
  data() {
    return {
      showTitle: false
    };
  },
  mounted() {
    this.showTitle = true;
    this.$nextTick(() => this.playVideo());
  },
  methods: {
    playVideo() {
      const videoEl: any = this.$refs.homeVideo;
      videoEl.controls = false;
    }
  }
});
